import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";
export const loginAction = (username, loginType) => {
    return dispatch => {
        dispatch({ type: actionType.LOADER_TRUE });
        axios.post(`${apiConstants().AUTH_API_URL}api/v1/auth/login`, { code: username, loginType: loginType }, {
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res) => {
            dispatch({ type: actionType.LOADER_FALSE })
            if (res.data.body) {
                localStorage.setItem("otpValues", JSON.stringify(res.data.body))
                dispatch({
                    type: actionType.OTP_SUCCESS,
                    user: res.data.body
                })
                toaster("success", res.data.message)
            } else {
                toaster("error", res.data.message)
            }
        }).catch(() => {
            dispatch({ type: actionType.LOADER_FALSE })
        })
    }
}

export const otpValidate = (payload, envType) => {
    return dispatch => {
        dispatch({ type: actionType.LOADER_TRUE });
        axios.post(`${apiConstants().AUTH_API_URL}api/v1/auth/validate`, payload, {

            headers: {
                "Content-Type": "application/json"
            }
        }).then((res) => {
            dispatch({ type: actionType.LOADER_FALSE })
            if (res.data.body) {
                localStorage.setItem("userDetails", JSON.stringify(res.data.body));
                localStorage.setItem('token', `${res.data.body.tokenType} ${res.data.body.accessToken}`)
                dispatch({
                    type: actionType.AUTH_SUCCESS,
                    user: res.data.body,
                    envType: envType
                });
                toaster("success", res.data.message)
            } else {
                toaster("error", res.data.message)
            }
        }).catch(() => {
            dispatch({ type: actionType.LOADER_FALSE })
        })
    }
}

